import { jsxs, jsx } from 'react/jsx-runtime';
import { useResourceImageBookmarkDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { ColorLabel } from '../../components/ColorLabel.js';
import { ResourcePreviewFavicon } from '../../components/ResourcePreviewFavicon.js';
import { ResourcePreviewTitle, ResourcePreviewDescription } from '../../components/Typography.js';
import { containerPreviewCompact } from '../cssPreviewContainer.js';
import { cssAspectRatio } from '../sharedCss.js';
import { styled, css } from 'styled-components';
import { IconBookmark } from '@fabric-app/icons/svg';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Image } from '@fabric-app/ui/components/Image';
import { cleanUrl } from '@fabric-app/utils/url';
import { useResourceListPreferencesContextUnsafe } from '../../../ResourceList/contexts/resourceListContextPreferences.js';
import { ResourceGridViewLoadingIndicator } from '../components/ResourceGridViewLoadingIndicator.js';

const ResourcePreviewImageBookmark = () => {
  const { resource, placeholderName } = useResourceImageBookmarkDataContextSafe();
  const url = resource.originUrl;
  const pref = useResourceListPreferencesContextUnsafe();
  const isAutoHeight = pref?.viewMode === "Masonry";
  return /* @__PURE__ */ jsxs(Wrapper, {
    "data-preview-content-wrapper": true,
    isAutoHeight,
    children: [
      /* @__PURE__ */ jsx(ColorLabel, {
        absPosition: "inside-top-left"
      }),
      /* @__PURE__ */ jsx(ResourceGridViewLoadingIndicator, {
        resource
      }),
      url && /* @__PURE__ */ jsx(ResourcePreviewFavicon, {
        pageUrl: url,
        position: "absolute-top-left",
        faviconUrl: resource.data.webpage?.favicon?.url
      }),
      resource.thumbnail?.md ? /* @__PURE__ */ jsx(ThumbnailImage, {
        src: resource.thumbnail.md,
        alt: resource.name || placeholderName,
        draggable: false
      }) : /* @__PURE__ */ jsx(EmptyImageState, {
        children: /* @__PURE__ */ jsx(IconBookmark, {
          style: {
            width: "4.25rem",
            height: "4.25rem"
          }
        })
      }),
      /* @__PURE__ */ jsxs(PageInfo, {
        children: [
          /* @__PURE__ */ jsx(ResourcePreviewTitle, {
            children: resource.name || placeholderName
          }),
          /* @__PURE__ */ jsx(ResourcePreviewDescription, {
            children: cleanUrl(url)
          })
        ]
      })
    ]
  });
};
const PageInfo = styled.div.withConfig({
  displayName: "ResourcePreviewImageBookmark__PageInfo",
  componentId: "sc-46a3ced4-0"
})([
  `display:flex;flex-direction:column;gap:0.3125rem;`
]);
const Wrapper = styled.div.withConfig({
  displayName: "ResourcePreviewImageBookmark__Wrapper",
  componentId: "sc-46a3ced4-1"
})([
  `width:100%;height:100%;display:flex;flex-direction:column;flex-grow:1;gap:0.625rem;overflow:hidden;justify-content:center;padding:0.75rem;border:var(--preview-border-width,2px) solid var(--preview-border-color,`,
  `);background:`,
  `;border-radius:var(--preview-content-border-radius,1.125rem);position:relative;`,
  ` `,
  `{border:none;border-radius:0;padding:0.6875rem;}`
], cssVar["color-border-secondary"], cssVar["color-bg-primary"], ({ isAutoHeight }) => !isAutoHeight ? cssAspectRatio : css([
  `min-height:150px;max-height:600px;`
]), containerPreviewCompact);
const ThumbnailImage = styled(Image).withConfig({
  displayName: "ResourcePreviewImageBookmark__ThumbnailImage",
  componentId: "sc-46a3ced4-2"
})([
  `width:100%;min-height:1px;flex-grow:1;object-fit:cover;display:block;border-radius:0.5rem;background:`,
  `;`
], cssVar["color-bg-section"]);
const EmptyImageState = styled.div.withConfig({
  displayName: "ResourcePreviewImageBookmark__EmptyImageState",
  componentId: "sc-46a3ced4-3"
})([
  `height:100;flex-grow:1;width:100%;max-width:100%;max-height:100%;display:flex;align-items:center;justify-content:center;border-radius:0.5rem;background:`,
  `;color:`,
  `;`
], cssVar["color-bg-section"], cssVar["color-bg-primary"]);

export { ResourcePreviewImageBookmark };
//# sourceMappingURL=ResourcePreviewImageBookmark.js.map
